export default "__VITE_ASSET__b0da370f__"